/**
 * Utility to reset all Pinia stores at once
 * This is useful during logout to clear all application state
 *
 * Uses the piniaResetPlugin to add $reset support to all stores
 * @see https://github.com/vuejs/pinia/discussions/911
 * @see https://pinia.vuejs.org/core-concepts/plugins.html
 */
import { getActivePinia } from 'pinia';

/**
 * Reset all Pinia stores to their initial state
 * Works with both Options API and Composition API (setup) stores
 * thanks to the piniaResetPlugin
 */
export const resetAllStores = () => {
  const pinia = getActivePinia();

  if (!pinia) {
    console.warn('No active Pinia instance found');
    return;
  }

  // Get all registered stores and call $reset on each
  // The $reset method is added by piniaResetPlugin for setup stores
  pinia._s.forEach((store) => {
    if (typeof store.$reset === 'function') {
      store.$reset();
    }
  });
};
